import { render } from "./PasswordModal.vue?vue&type=template&id=0d444ccf"
import script from "./PasswordModal.vue?vue&type=script&lang=js"
export * from "./PasswordModal.vue?vue&type=script&lang=js"

import "./PasswordModal.vue?vue&type=style&index=0&id=0d444ccf&lang=css"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__